type SmartImageProps = {
  name: string;
  alt: string;
  className?: string;
  eager?: boolean;
  width?: number;
  height?: number;
  sizes?: string;
};

export function SmartImage({ name, alt, className, eager = false, width = 1280, height = 853, sizes = '(max-width: 767px) 100vw, 50vw' }: SmartImageProps) {
  return (
    <picture className={className ? `${className} picture` : 'picture'}>
      <source type="image/avif" srcSet={`/images/${name}-640.avif 640w, /images/${name}-1280.avif 1280w, /images/${name}-2000.avif 2000w`} sizes={sizes} />
      <source type="image/webp" srcSet={`/images/${name}-640.webp 640w, /images/${name}-1280.webp 1280w, /images/${name}-2000.webp 2000w`} sizes={sizes} />
      <img
        src={`/images/${name}-1280.jpg`}
        srcSet={`/images/${name}-640.jpg 640w, /images/${name}-1280.jpg 1280w, /images/${name}-2000.jpg 2000w`}
        sizes={sizes}
        alt={alt}
        width={width}
        height={height}
        loading={eager ? 'eager' : 'lazy'}
        fetchPriority={eager ? 'high' : 'auto'}
        decoding="async"
      />
    </picture>
  );
}
